export type IconSize = '2xs' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | 'inherit';

export const iconSizeMap: Record<IconSize, string> = {
  '2xs': '2xs',
  xs: 'xs',
  sm: 'sm',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  /** height is set from parent */
  inherit: 'inherit'
};

export type IconType =
  | 'nav'
  | 'profile'
  | 'search'
  | 'angleRight'
  | 'angleDown'
  | 'filter'
  | 'sort'
  | 'sector'
  | 'pin'
  | 'up'
  | 'down'
  | 'email'
  | 'phone'
  | 'linkedin'
  | 'dragDrop'
  | 'edit'
  | 'print'
  | 'copy'
  | 'trash'
  | 'archive'
  | 'sliders-h'
  | 'filter-alt'
  | 'bookmark'
  | 'thumbtack'
  | 'download'
  | 'upload'
  | 'undo'
  | 'microphone'
  | 'eye'
  | 'user'
  | 'user-plus'
  | 'caret-down'
  | 'minus'
  | 'chevron-down'
  | 'chevron-up'
  | 'plus'
  | 'caret-up'
  | 'chevron-left'
  | 'chevron-right'
  | 'ellipsis-h'
  | 'ellipsis-v'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-up'
  | 'arrow-down'
  | 'bars'
  | 'cog'
  | 'circle-notch'
  | 'times'
  | 'external-link'
  | 'home'
  | 'shopping-cart'
  | 'check'
  | 'check-circle'
  | 'exclamation-circle'
  | 'lock'
  | 'exclamation-triangle'
  | 'bell'
  | 'thumbs-up'
  | 'envelope'
  | 'map-marker-alt'
  | 'comment'
  | 'share'
  | 'link'
  | 'th-large'
  | 'list'
  | 'list-dropdown'
  | 'table'
  | 'star'
  | 'chart-pie-alt'
  | 'chart-pie'
  | 'chart-area'
  | 'chart-bar'
  | 'file'
  | 'file-alt'
  | 'file-powerpoint'
  | 'file-pdf'
  | 'file-excel'
  | 'folder'
  | 'usd-circle'
  | 'calendar'
  | 'calculator'
  | 'info-circle'
  | 'sticky-note'
  | 'video'
  | 'audio'
  | 'certified'
  | 'warningTriangle'
  | 'shield-check'
  | 'objectsColumn'
  | 'spinner-third'
  | 'x';

//  maps the icon type to the underlying fontawesome icon
export const iconClassNameFaMap: Record<IconType, string> = {
  nav: 'fa-bars',
  profile: 'fa-id-badge',
  search: 'fa-magnifying-glass',
  angleRight: 'fa-angle-right',
  angleDown: 'fa-angle-down',
  filter: 'fa-filter',
  sort: 'fa-sort',
  sector: 'fa-id-badge',
  pin: 'fa-thumbtack',
  up: 'fa-arrow-up',
  down: 'fa-arrow-down',
  email: 'fa-envelope',
  phone: 'fa-phone',
  linkedin: 'fa-brands fa-linkedin',
  dragDrop: 'fa-up-down-left-right',
  edit: 'fa-pen-to-square',
  print: 'fa-print',
  copy: 'fa-copy',
  trash: 'fa-trash',
  archive: 'fa-box-archive',
  'sliders-h': 'fa-sliders',
  'filter-alt': 'fa-filter',
  bookmark: 'fa-bookmark',
  thumbtack: 'fa-thumbtack',
  download: 'fa-download',
  upload: 'fa-upload',
  undo: 'fa-arrow-rotate-left',
  microphone: 'fa-microphone',
  eye: 'fa-eye',
  user: 'fa-user',
  'user-plus': 'fa-user-plus',
  'caret-down': 'fa-caret-down',
  minus: 'fa-minus',
  'chevron-down': 'fa-chevron-down',
  'chevron-up': 'fa-chevron-up',
  plus: 'fa-plus',
  'caret-up': 'fa-caret-up',
  'chevron-left': 'fa-chevron-left',
  'chevron-right': 'fa-chevron-right',
  'ellipsis-h': 'fa-ellipsis',
  'ellipsis-v': 'fa-ellipsis-vertical',
  'arrow-right': 'fa-arrow-right',
  'arrow-left': 'fa-arrow-left',
  'arrow-up': 'fa-arrow-up',
  'arrow-down': 'fa-arrow-down',
  bars: 'fa-bars',
  cog: 'fa-gear',
  'circle-notch': 'fa-circle-notch',
  times: 'fa-xmark',
  'external-link': 'fa-arrow-up-right-from-square',
  home: 'fa-house',
  'shopping-cart': 'fa-cart-shopping',
  check: 'fa-check',
  'check-circle': 'fa-circle-check',
  'exclamation-circle': 'fa-circle-exclamation',
  lock: 'fa-lock',
  'exclamation-triangle': 'fa-triangle-exclamation',
  bell: 'fa-bell',
  'thumbs-up': 'fa-thumbs-up',
  envelope: 'fa-envelope',
  'map-marker-alt': 'fa-location-dot',
  comment: 'fa-comment',
  share: 'fa-share',
  link: 'fa-link',
  'th-large': 'fa-table-cells-large',
  list: 'fa-list',
  'list-dropdown': 'fa-list-dropdown',
  table: 'fa-table-cells',
  star: 'fa-star',
  'chart-pie-alt': 'fa-chart-pie-simple',
  'chart-pie': 'fa-chart-pie',
  'chart-area': 'fa-chart-area',
  'chart-bar': 'fa-chart-bar',
  file: 'fa-file',
  'file-alt': 'fa-file-lines',
  'file-powerpoint': 'fa-file-powerpoint',
  'file-pdf': 'fa-file-pdf',
  'file-excel': 'fa-file-excel',
  folder: 'fa-folder',
  'usd-circle': 'fa-circle-dollar',
  calendar: 'fa-calendar',
  calculator: 'fa-calculator',
  'info-circle': 'fa-circle-info',
  'sticky-note': 'fa-note-sticky',
  video: 'fa-video',
  audio: 'fa-volume',
  certified: 'shield-check',
  warningTriangle: 'fa-triangle-exclamation',
  'shield-check': 'fa-shield-check',
  objectsColumn: 'fa-objects-column',
  'spinner-third': 'fa-spinner-third',
  x: 'fa-x'
};
